module.exports = function (a, b) {
    if (a === null || a === undefined) {
        return b
    }

    if (typeof a === 'string' && a.trim() === '') {
        return b
    }

    return a
}
